<arm-dialog (onSubmit)="ok()"
            [hideCancelButton]="true"
            [title]="'Action Failed'">
    <div class="content">
        <div class="message-header">
            <mat-icon class="error-icon" color="warn">error</mat-icon>
            <span>An error occurred. See details below.</span>
        </div>
        <mat-divider></mat-divider>
        <span class="error-message">{{errorDetails}}</span>
    </div>
</arm-dialog>
